import { Box, Typography, RadioGroup, FormControlLabel, Radio, FormControl } from '@mui/material';
import CustomersApiService from 'api/CustomersApiService';
import { Layout } from 'components';
import useApi from 'hooks/useApi';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'store/hooks';
import Customer from 'types/entities/Customer';
import { ActionDescriptor } from 'types/enums/ActionDescriptor';

const DashboardNotification: React.FC = () => {
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>, value: string) => {
    setValue(value);
    const dataToUpdate: Partial<Customer> = {
      client_connection: appState.customer?.client_connection,
      action_id: ActionDescriptor.TenantSaveModifications,
    };
    const res = makeCall(
      CustomersApiService.updateCustomer(appState.customer?.id as number, dataToUpdate),
      'Unable to save customer'
    );
  };
  const appState = useSelector((state) => state.app);
  const { makeCall } = useApi();
  const [t] = useTranslation();
  const [value, setValue] = React.useState<string>('real-time');

  return (
    <Layout name="Settings" path="/dashboard-notification">
      <Box sx={{ borderBottom: 2, borderColor: 'divider', marginBottom: 2 }}>
        <Typography variant="h2" sx={{ fontWeight: 700, mb: 1 }}>
          {t('Dashboard_Notifications_Title')}
        </Typography>
        <Typography variant="body2" sx={{ marginBottom: 2 }}>
          {t('Critical_Account_Notifications')}
        </Typography>
      </Box>
      <FormControl component="fieldset" sx={{ marginBottom: 2 }}>
        <RadioGroup
          aria-label="notification-settings"
          name="notification-settings"
          value={value}
          onChange={handleChange}
        >
          <FormControlLabel value="real-time" control={<Radio />} label={t('Realtime_Notifications_Default')} />
          <Typography variant="body2" sx={{ marginBottom: 1 }}>
            {t('Receive_Every_Update')}
          </Typography>
          <FormControlLabel value="minimal" control={<Radio />} label={t('Minimal_Notifications')} />
          <Typography variant="body2" sx={{ marginBottom: 1 }}>
            {t('Key_Updates_Only')}
          </Typography>
          <FormControlLabel value="de-activate" control={<Radio />} label={t('Deactivate_Notifications')} />
          <Typography variant="body2" sx={{ marginBottom: 1 }}>
            {t('Stay_Distraction_Free')}
          </Typography>
        </RadioGroup>
      </FormControl>
    </Layout>
  );
};
export default DashboardNotification;
